// extracted by mini-css-extract-plugin
module.exports = {"control":"CheckoutForm_control__2grdc","wrapper":"CheckoutForm_wrapper__1zrPJ","confirm":"CheckoutForm_confirm__2hRIr","price":"CheckoutForm_price__39Y4B"};